import { getPublic, putPublic, put, get } from "../../data/api";

export async function getCheckout(id) {
    return await getPublic('public/payment/return/' + id)
}
export async function paymentCall(rentalId) {
    return await getPublic('public/sumup/payment/' + rentalId)
}
export async function advancePaymentCall(rentalId) {
    return await getPublic('public/sumup/advance-payment/' + rentalId)
}